import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigService } from '../core/config/config.service';
import { EfetuarVendaDTO } from '../models/venda-v2.model';

@Injectable({ providedIn: 'root' })
export class VendaV2Service {

  private readonly http          = inject(HttpClient);
  private readonly configService = inject(ConfigService);

  private get endpointUrl(): string {
    return `${this.configService.settings()?.apiUrl}/financeiro/v2/vendas`;
  }

  /**
   * POST /financeiro/v2/vendas
   * Efetua uma nova venda (à vista, parcelada ou mista com entrada).
   * Retorna 200 sem corpo.
   */
  efetuarVenda(dto: EfetuarVendaDTO): Observable<void> {
    return this.http.post<void>(this.endpointUrl, dto);
  }

  /**
   * POST /financeiro/v2/vendas/baixar-parcela
   * Adiciona um pagamento a uma venda mista existente.
   * Recebe o mesmo EfetuarVendaDTO — localiza a venda pelo idOrcamento.
   * Retorna 200 sem corpo.
   */
  baixarParcela(dto: EfetuarVendaDTO): Observable<void> {
    return this.http.post<void>(`${this.endpointUrl}/baixar-parcela`, dto);
  }
}
